<div [class]="cssClassSuffix ? 'main next-notification next-notification--' + cssClassSuffix : 'main next-notification'"
     [ngClass]="{'notification--loading': loading}"
>
    <div *ngIf="title || descriptions"
         class="next-notification__text">
        <div class="next-notification__text__title"
             *ngIf="title"
             [innerHTML]="title | translate | safeHtml"
        ></div>
        <div class="next-notification__text__descriptions"
             *ngIf="descriptions"
        >
            <div *ngFor="let description of descriptions"
                 class="next-notification__text__description"
                 [innerHTML]="description | translate | safeHtml"
            ></div>
        </div>
        <div *ngIf="buttonLabel && !processInfoVisible"
             class="next-notification__text__button">
            <button class="btn btn--secondary"
                    (click)="onButtonClick()">
                {{ buttonLabel | translate}}
            </button>
        </div>
    </div>
    <div *ngIf="imageSrc"
         class="next-notification__image">
        <img class="next-notification__image__image--desktop" [src]="imageSrc" alt="">
        <img class="next-notification__image__image--mobile" [src]="imageSrcMobile ? imageSrcMobile : imageSrc" alt="">
    </div>

    <div *ngIf="processInfoVisible"
         class="next-notification__process-info">
        <div *ngIf="sessionMessage"
             [innerHTML]="sessionMessage | safeHtml"
             class="next-notification__process-info__message">
        </div>
        <app-container-spinner *ngIf="loading"
                               class="next-notification__process-info__spinner">
        </app-container-spinner>
        <div *ngIf="buttonLabel"
             class="next-notification__process-info__button">
            <button class="btn btn--secondary"
                    (click)="onButtonClick()">
                {{ buttonLabel | translate}}
            </button>
        </div>
    </div>

</div>
